/* global axios */
import ApiClient from './ApiClient';

export class KanbansAPI extends ApiClient {
  constructor() {
    super('kanbans', { accountScoped: true });
  }

  getStages({ kanbanId }) {
    return axios.get(`${this.url}/${kanbanId}/kanban_stages`);
  }

  createStage({ kanbanId, ...data }) {
    return axios.post(`${this.url}/${kanbanId}/kanban_stages`, {
      kanban_stage: data,
    });
  }

  updateStage({ kanbanId, id, ...data }) {
    return axios.patch(`${this.url}/${kanbanId}/kanban_stages/${id}`, {
      kanban_stage: data,
    });
  }

  deleteStage({ kanbanId, id }) {
    return axios.delete(`${this.url}/${kanbanId}/kanban_stages/${id}`);
  }

  getAgents({ kanbanId }) {
    return axios.get(`${this.url}/${kanbanId}/kanban_members`);
  }

  addAgents({ kanbanId, agentsList }) {
    return axios.post(`${this.url}/${kanbanId}/kanban_members`, {
      user_ids: agentsList,
    });
  }

  updateAgents({ kanbanId, agentsList }) {
    return axios.patch(`${this.url}/${kanbanId}/kanban_members`, {
      user_ids: agentsList,
    });
  }

  getStageAutomation({ kanbanId, stageId }) {
    return axios.get(
      `${this.url}/${kanbanId}/kanban_stages/${stageId}/automation`
    );
  }

  updateStageAutomation({ kanbanId, stageId, ...data }) {
    return axios.patch(
      `${this.url}/${kanbanId}/kanban_stages/${stageId}/automation`,
      { kanban_stage_automation: data }
    );
  }

  createCard({ kanbanId, ...data }) {
    return axios.post(`${this.url}/${kanbanId}/cards`, data);
  }

  getPrivateNotes({ kanbanId, conversationIds }) {
    return axios.get(`${this.url}/${kanbanId}/cards/private_notes`, {
      params: { conversation_ids: conversationIds },
    });
  }
}

export default new KanbansAPI();
